import FreshwatchGroupCard from '../../../../../../customized/fresh-watch/components/DeviceManager/GroupsOverview/GroupCard/FreshwatchGroupCard';
import { ToggleComponent } from '../../../../../../featureToggle';
import { GroupCard } from './GroupCard';

export default ToggleComponent(GroupCard, {
  styledComponentsVariants: {
    'fresh-watch': FreshwatchGroupCard,
  },
});
